import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="border-t-4 border-oro bg-noche-dark pb-16" data-id="element-70" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-5" data-id="element-71" data-mp="32nukakr5twzs">
        <p className="text-xs leading-snug text-white" data-id="element-72" data-mp="32pp764lzrz6i">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-1 text-[11px] leading-snug text-white/70" data-id="element-73" data-mp="36n3chl6jxmt8">
          {PRODUCT_NAME} es un producto educativo complementario. No sustituye
          los diseños curriculares oficiales, la formación docente, los
          materiales obligatorios de cada institución ni los criterios
          pedagógicos de profesionales habilitados. Las actividades,
          evaluaciones y planificaciones deben adaptarse al nivel, curso,
          jurisdicción y necesidades de los estudiantes.
        </p>
        <p className="mt-1.5 text-xs text-white" data-id="element-74" data-mp="2a1jjb8zn5u2g">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-oro transition-colors duration-150 ease-out hover:text-white" data-id="element-75" data-mp="2ezl3xycpu1g1">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1.5 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-xs text-white" data-id="element-76" data-mp="3gctmyhqo8do6">
          <a href="#terminos" className="transition-colors duration-150 ease-out hover:text-oro" data-id="element-77" data-mp="3q7bvc0718xeb">
            Términos y Condiciones
          </a>
          <span className="text-oro" aria-hidden="true" data-id="element-78" data-mp="335u5kj2dpi2">•</span>
          <a href="#privacidad" className="transition-colors duration-150 ease-out hover:text-oro" data-id="element-79" data-mp="htd1p57j9o3z">
            Política de Privacidad
          </a>
          <span className="text-oro" aria-hidden="true" data-id="element-80" data-mp="qthyklf3p43w">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-out hover:text-oro" data-id="element-81" data-mp="qtroya425da4">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}